// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderResultSearchDefaultResponse {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderResultSearchDefaultResponse.attributeTypeMap;
    }
}
PharmacyV1CardFinderResultSearchDefaultResponse.discriminator = undefined;
PharmacyV1CardFinderResultSearchDefaultResponse.additionalProperties = false;
PharmacyV1CardFinderResultSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyV1CardFinderResultSearchDefaultResponseData"
    },
];
//# sourceMappingURL=pharmacyV1CardFinderResultSearchDefaultResponse.js.map